import screen from "../common/screen";

function clamp (params = {}) {
    const { value, min, max } = params;
    return Math.min(Math.max(value, min), max);
}

let { map } = Array.prototype;

const fixHeader = () => {
    const $header = document.getElementById("header");
    const $template = document.getElementById('design-template');
    const $ads = document.querySelectorAll("#ad-north-rsvp, #ad_mobile_top, #header")::map(el => el.parentNode);
    const $navContainer = document.querySelector('.nav-container');
    const $actionBar = document.querySelector('.action-bar');
    const $fullPreviewBar = document.querySelector("#full_preview_bar");
    let navTop = 0;
    
    // only call handleScroll() if header is not sticky
    if (!evite.experiments.inExperiment('sticky_header')) {
        document.addEventListener('scroll', handleScroll);
        handleScroll();
    }

    function handleScroll() {
        if (!$header) {
            return
        }
        let headerMarginTop = 0;
        let scrollTop = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
        if (!screen.isSmall()) {
            headerMarginTop = calculateHeaderMarginTop(scrollTop);
        }
        $header.style.marginTop = headerMarginTop + "px";
        navTop = scrollTop + headerMarginTop;
    }

    function calculateHeaderMarginTop(scrollTop){
        const templateHeight = $template ? $template.clientHeight : 0;
        const actionBarHeight = $actionBar ? $actionBar.clientHeight : 0;
        const navHeight = $navContainer ? $navContainer.clientHeight : 0;
        const fadeBoundary = $actionBar ? templateHeight - actionBarHeight : templateHeight - navHeight;
        const adTop = $actionBar ?
            Math.max(0, fadeBoundary) :
            Math.max(0, fadeBoundary + navHeight);

        if(scrollTop <= adTop){
            return 0;
        }

        let inverseNavSize = -1 * ($header.clientHeight);

        if (window.cookie_dismissed) {
            window.cookie_dismissed = false;
            inverseNavSize = inverseNavSize + 30;
        }

        let isBetweenAdTopAndSubNav = scrollTop > adTop && scrollTop < (adTop - inverseNavSize);
        let isBetweenNavBoundaryAndSubNav = scrollTop < navTop && scrollTop < (navTop - inverseNavSize);

        if (isBetweenAdTopAndSubNav && isBetweenNavBoundaryAndSubNav) {
            return clamp({value: inverseNavSize + navTop - scrollTop, min: inverseNavSize, max: 0});
        }
        else if (screen.isLarge() && isBetweenAdTopAndSubNav) {
            return clamp({value: adTop - scrollTop, min: inverseNavSize, max: 0});
        }
        else if (screen.isMedium()){
            return clamp({value: adTop - scrollTop, min: inverseNavSize + navHeight, max: 0});
        }

        let adMargin = $ads.length ? -1 * $header.clientHeight : -50;

        if ($fullPreviewBar) {
            adMargin -= $fullPreviewBar.clientHeight
        }

        if (isBetweenNavBoundaryAndSubNav) {
            return clamp({value: inverseNavSize + navTop - scrollTop, min: inverseNavSize, max: adMargin});
        }

        return inverseNavSize;
    }
};

export default fixHeader


// WEBPACK FOOTER //
// ./assets/es6/nav/subnav.es6